import React, { useState, useEffect } from 'react';
import './HomePage.css';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Autoplay, EffectCoverflow, EffectFade } from "swiper/modules"
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/effect-coverflow";
import "swiper/css/effect-fade";
import AlumniSpotlight from "./AlumniSpotlight"; 
import { Link, useNavigate } from 'react-router-dom';
// import Lamp from "./Lamp";
import TrendingSection from "./TrendingSection";
import EventsSection from "./EventsSection";

const Homepage = () => {
  const [/*hoveredCard*/, setHoveredCard] = useState(null);
  const [showPopup, setShowPopup] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate(); // To handle redirection
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    const role = localStorage.getItem('role');
    console.log("Retrieved Role from Local Storage:", role); // Debugging
    setUserRole(role ? role.toLowerCase() : null);
}, []);

  const handleClose = () => {
    setIsClosing(true); // Start fade-out animation
    setTimeout(() => {
      setShowPopup(null); // Remove popup after animation completes
      setIsClosing(false); // Reset state for future popups
    }, 500); // Matches the animation duration in CSS
  };


  const handleLogoClick = () => {
    navigate('/'); // Redirect to homepage instead of /login
  };


  const eventData = [
    {
      title: "Alumni Speaks 01",
      description: "Event 1 Full Details",
      // images: ["https://mbaworld.in/assets/images/colleges/dsbp.JPG", "./assets/sucessful_saturdays/week-1.png", "./assets/sucessful_saturdays/week-1.png"],
      images:["/media/AlumniSpeaks01/6.JPG"],
      
    },
    {
      title: "Alumni Speaks 02",
      description: "Event 2 Full Details",
      // images: ["/images/event2.jpg", "/images/event2-2.jpg"],
      images:["/media/AlumniSpeaks02/2.jpg"],
    },
    {
      title: "Alumni Speaks 03",
      description: "Event 3 Full Details",
      // images: ["/images/event3.jpg", "/images/event3-2.jpg"],
      images:["/media/AlumniSpeaks03/11.JPG"],
    },
    {
      title: "Alumni Speaks 04",
      description: "Event 4 Full Details",
      // images: ["/images/event4.jpg", "/images/event4-2.jpg", "/images/event4-3.jpg"],
      images:["/media/AlumniSpeaks04/3.jpg"],
    },
  ];

  const alumniData = [

    {
      id: 1,
      name: "Week 1",
      image: "./assets/sucessful_saturdays/week-1.png",
      designation: "Week 1",
    },
    {
      id: 2,
      name: "Week-2",
      image: "./assets/sucessful_saturdays/week-2.png",
      designation: "Week 2",
    },
    {
      id: 3,
      name: "Week 3",
      image: "./assets/sucessful_saturdays/week-3.png",
      designation: "Week 3",
    },

    {
      id: 4,
      name: "Week 4",
      image: "./assets/sucessful_saturdays/week-4.png",
      designation: "Week 4",
    },

    {
      id: 5,
      name: "Week 5",
      image: "./assets/sucessful_saturdays/week-5.png",
      designation: "Week 5",
    },

    {
      id: 6,
      name: "Week 6",
      image: "./assets/sucessful_saturdays/week-6.png", 
      designation: "Week 6",
    },

    {
      id: 7,
      name: "Week 7",
      image: "./assets/sucessful_saturdays/week-7.png",
      designation: "Week 7",
    },

    {
      id: 8,
      name: "Week 8",
      image: "./assets/sucessful_saturdays/week-8.png",
      designation: "Week 8",
    },

    {
      id: 9,
      name: "Week 9",
      image: "./assets/sucessful_saturdays/week-9.png",
      designation: "Week 9",
    },

    {
      id: 10,
      name: "Week 10",
      image: "./assets/sucessful_saturdays/week-10.png",
      designation: "Week 10",
    },

    {
      id: 11,
      name: "Week 11",
      image: "./assets/sucessful_saturdays/week-11.png",
      designation: "Week 11",
    },

    {
      id: 12,
      name: "Week 12",
      image: "./assets/sucessful_saturdays/week-12.png",
      designation: "Week 12",
    },
  ];


  const cards = [
    { id: 1, title: 'Alumni Connect', description: 'Join us!', fullContent: 'Full details for Event 1.', image: '../assets/homepage_events/1.jpeg' },
    { id: 2, title: 'Biz Bazaar', description: 'Join us!', fullContent: 'Full details for Event 2.', image: '../assets/homepage_events/2.jpeg' },
    { id: 3, title: 'Buried Truths', description: 'Join us!', fullContent: 'Full details for Event 3.', image: '../assets/homepage_events/3.jpeg' },
    { id: 4, title: 'Brainwave', description: 'Join us!', fullContent: 'Full details for Event 4.', image: '../assets/homepage_events/4.jpeg' },
    { id: 5, title: 'Alumni Connect', description: 'Join us!', fullContent: 'Full details for Event 1.', image: '../assets/homepage_events/1.jpeg' },
    { id: 6, title: 'Biz Bazaar', description: 'Join us!', fullContent: 'Full details for Event 2.', image: '../assets/homepage_events/2.jpeg' },
    { id: 7, title: 'Buried Truths', description: 'Join us!', fullContent: 'Full details for Event 3.', image: '../assets/homepage_events/3.jpeg' },
    { id: 8, title: 'Brainwave', description: 'Join us!', fullContent: 'Full details for Event 4.', image: '../assets/homepage_events/4.jpeg' },
    // { id: 5, title: 'Event 5', description: 'Join us for Event 5!', fullContent: 'Full details for Event 5.', image: 'path-to-event4-image' },
    // { id: 6, title: 'Event 6', description: 'Join us for Event 6!', fullContent: 'Full details for Event 5.', image: 'path-to-event4-image' },
  ];

  return (
    <div className="homepage">
      {/* Header Section */}
      <header className="header">
        <h1>Alumni Relations Committee</h1>
        <h2>Vivekananda School of Economics</h2>
<p>Creating Legacies, Building Future</p>
        {/* Show register button only if userRole is null */}

        { (!userRole || (typeof userRole === 'string' && !['student', 'alumni', 'admin'].includes(userRole.toLowerCase()))) && (
  <Link to="/pages/registration">
    <button className="register-button">Register as Alumni/Student</button>
  </Link>
)}

</header>
<br></br>
       {/* About Section */}
       <section className="about-section" >
        <div className="about-image">
          <img src="https://directadmissioninfo.com/wp-content/uploads/2024/03/VIPS-Pitampura-1.jpeg" alt="About the Committee" />
        </div>
        <div className="about-content">
          <h2>About Alumni Relations Committee VSE</h2>
          <p>

          The <b>Alumni Relations Committee (ARC)</b> of VSE serves as a vital bridge between students and alumni, fostering a strong and engaged community. Our mission is to create meaningful connections through mentorship, networking, and career development, ensuring that alumni remain an integral part of VSE’s legacy.  
 <br>
</br><br>
</br><a onClick={() => setShowPopup('about')}>Read more...</a>
          </p>
        </div>
      </section>

      {/* Popup for About Section */}
      {showPopup === 'about' && (
        <div className="popup">
           <div className={`popup-content ${isClosing ? "fade-out" : ""}`}>
            <p>
              <br></br>
              <br></br>
              <br></br>
            The <b>Alumni Relations Committee (ARC)</b> of VSE serves as a vital bridge between students and alumni, fostering a strong and engaged community. Our mission is to create meaningful connections through mentorship, networking, and career development, ensuring that alumni remain an integral part of VSE’s legacy.  
             <br></br><br></br>
Through a range of initiatives, we provide valuable industry insights and professional growth opportunities. Our Alumni Speaks series brings accomplished graduates back to share their experiences, guiding current students in their career journeys. Guest lectures, networking events, and mentorship programs offer a platform for alumni to inspire, collaborate, and support the next generation of professionals.  
<img src="../assets/homepage_assets/about_1.jpeg" alt="About the Committee" className="popup-content" /> <br />
By celebrating achievements, strengthening ties, and facilitating lifelong learning, ARC helps alumni stay connected with their alma mater while contributing to the success of future graduates. Whether through mentorship, knowledge sharing, or professional opportunities, we are committed to building a thriving alumni network that extends beyond graduation.<br></br><br></br>

<br></br><br></br>
<img src="../assets/homepage_assets/about_2.png" alt="About the Committee" className="popup-content" />


            </p>
            <button onClick={handleClose}>Close</button>
          </div>
        </div>
      )}



     <div>
      <EventsSection cards={cards} />
    </div> 

      {/* Mission and Vision Section */}
      <section className="mission-section">
      <div className="mission-image">
{/*           <img src="https://mbaworld.in/assets/images/colleges/dsbp.JPG" alt="Mission and Vision" /> */}
        <img src="../assets/homepage_assets/mission_vision.jpg" alt="Mission and Vision" />
        </div>
        <div className="mission-content">
        <h2>Our Mission and Vision</h2>
        <p>
      


       <h4>Mission</h4> 

The Alumni Relations Committee (VSE) fosters lasting connections between alumni and their alma mater through mentorship, networking, and lifelong learning. By celebrating achievements and strengthening ties, we build a thriving community rooted in excellence and impact.

<h4>Vision</h4>

The Alumni Relations Committee (VSE) cultivates a prestigious network, uniting graduates through mentorship, collaboration, and professional growth while preserving the institution’s esteemed legacy.




<br></br>
<br></br>
         
        </p>
        </div>
      </section>

      

      <div>
      {/* Other sections of homepage */}
      <TrendingSection alumniData={alumniData} eventData={eventData} />
    </div>

    <div>
  <h2 style={{ fontSize: "35px", textAlign: "center", marginTop: "50px" }}>
    Alumni Spotlight
  </h2>
  <AlumniSpotlight />
</div>



<section className="dean-section">
  {/* <div className="content-left">
  <img src="../assets/homepage_assets/PHOTO-2025-03-15-12-46-15.jpg" alt="Dean" />
    
  </div>
  <div className="image-right">
  <h2>From the Chairman's Desk</h2>
    <p>
    <b>Swami Vivekananda</b> once said, <i>‘We want an education by which character is formed, strength of mind is increased, and intellect is expanded, by which one can stand on one’s feet.’</i> &nbsp; It is this very vision that has guided the journey of the Vivekananda Institute of Professional Studies - Technical Campus (VIPS-TC), founded in 2000 under the banner of STRENGTH India Educational Society.
<br />
<br />
    From its inception, VIPS has been committed to fostering education that empowers its students to become individuals of strength, character, and intellect.The Alumni Relations Committee, we take immense pride in the achievements of our vibrant alumni network, whose contributions reflect the values of integrity, excellence, and moral clarity imparted during their time at VIPS. With sixteen diverse courses, VIPS has shaped and continues to shape individuals who stand firm in the face of challenges, ready to contribute positively to society
    <br></br>
      <br />
      <a onClick={() => setShowPopup('dean')}>Read more...</a>
    </p>
  </div> */}
  <div className="chairman-section">
<div className="dean-section">
  <div className="dean-image">
    <img src="../assets/homepage_assets/PHOTO-2025-03-15-12-46-15.jpg" alt="Chairman" />
  </div>

  <div className="dean-text">
    <h2>From the Chairman's Desk</h2>
    <p>
      <b>Swami Vivekananda</b> once said, <i>‘We want an education by which character is formed, strength of mind is increased, and intellect is expanded, by which one can stand on one’s feet.’</i> &nbsp;
      It is this very vision that has guided the journey of the Vivekananda Institute of Professional Studies - Technical Campus (VIPS-TC), founded in 2000 under the banner of STRENGTH India Educational Society.
      <br /><br />
      From its inception, VIPS has been committed to fostering education that empowers its students to become individuals of strength, character, and intellect.
      <br /><br />
      The Alumni Relations Committee, we take immense pride in the achievements of our vibrant alumni network, whose contributions reflect the values of integrity, excellence, and moral clarity imparted during their time at VIPS.
      <br /><br />

    </p>
    <a onClick={() => setShowPopup('chairman')} >Read more...</a>
  </div>
</div>
</div>
  

    {/* Popup for Dean Section */}
  {showPopup === 'chairman' && (
    <div className="popup">
      <div className={`popup-content ${isClosing ? "fade-out" : ""}`}>
     
        <br></br>
        <br></br>
        <p>
        Swami Vivekananda once said, ‘We want an education by which character is formed, strength of mind is increased, and intellect is expanded, by which one can stand on one’s feet.’ It is this very vision that has guided the journey of the Vivekananda Institute of Professional Studies - Technical Campus (VIPS-TC), founded in 2000 under the banner of STRENGTH India Educational Society.
<br /><br /><br />
From its inception, VIPS has been committed to fostering education that empowers its students to become individuals of strength, character, and intellect. We take immense pride in the achievements of our vibrant alumni network, whose contributions reflect the values of integrity, excellence, and moral clarity imparted during their time at VIPS. With sixteen diverse courses, VIPS has shaped and continues to shape individuals who stand firm in the face of challenges, ready to contribute positively to society.
<br /><br /><br />
Alumni Relations Committee endeavours to build and maintain lasting relationships with our alumni, ensuring that their achievements continue to inspire and guide both current and future generations. We aim to create a dynamic, engaged community that not only celebrates the legacy of VIPS but also strengthens the connection between the institution and its alumni. Together, we uphold Swami Vivekananda’s vision of nurturing capable, ethical, and empowered individuals who make meaningful contributions to the world.
        </p>
        <button onClick={handleClose}>Close</button>
      </div>
    </div>
  )}
  
</section>










<section className="dean-section">
  <div className="content-left">
    <h2>Message from The Dean</h2>
    <p>
    At <b>The Vivekananda School of Economics (VSE)</b>, our alumni have always been a source of pride for us. Many of you have gone on to make remarkable contributions to diverse fields, both within and outside of economics. Your success stories inspire current and future generations of students. As we continue to foster a strong sense of community and mutual support among our alumni, we invite you to stay connected with your alma mater, share your experiences, and contribute to the growth of our department.
    <br></br>
      <br />
      <a onClick={() => setShowPopup('dean')}>Read more...</a>
    </p>
  </div>
  <div className="image-right">
    <img src="../assets/homepage_assets/dean.png" alt="Dean" />
  </div>

  {/* Popup for Dean Section */}
  {showPopup === 'dean' && (
    <div className="popup">
      <div className={`popup-content ${isClosing ? "fade-out" : ""}`}>
        <br></br>
        <br></br>
        <br></br>
    
        
        
        <p>
        At the Vivekananda School of Economics (VSE), our alumni have always been a source of pride for us. Many of you have gone on to make remarkable contributions to diverse fields, both within and outside of economics. Your success stories inspire current and future generations of students. As we continue to foster a strong sense of community and mutual support among our alumni, we invite you to stay connected with your alma mater, share your experiences, and contribute to the growth of our department.
<br /><br /><br />
We look forward to your continued engagement and hope to see many of you at future alumni events, where we can celebrate our shared journey and achievements.

I hope that current students draw inspiration from the exceptional qualities demonstrated by our alumni and actively seize the numerous opportunities that VSE offers. By learning from the experiences and successes of our alumni, students can better navigate their academic and professional journeys, leveraging the resources and networks available to them at VSE.
        </p>
        <button onClick={handleClose}>Close</button>
      </div>
    </div>
  )}
</section>



</div>
  );
};

export default Homepage;





















